import { faCheck, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { IDistrict } from "../../../redux/slices/appSlice";
import { loginUser } from "../../../redux/slices/userSlice";
import useFetch, { API_BASE_URL } from "../../../utils/useFetch";
import OtpInput from "react-otp-input";

const SignUp = () => {
  const { data: districts } = useFetch<IDistrict[]>("districts");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [district, setDistrict] = useState("0");
  const [address, setAddress] = useState("");
  const [verifyCode, setVerifyCode] = useState("");
  const [isSendingData, setIsSendingData] = useState(false);
  const [showPhoneVerifyForm, setShowPhoneVerifyForm] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const signUpFetch = async () => {
    const _formData = new FormData();
    _formData.append("name", name);
    _formData.append("phone", phone);
    _formData.append("region", district);
    _formData.append("address", address);
    setIsSendingData(true);
    const response = await fetch(API_BASE_URL + "register1", {
      method: "POST",
      body: _formData,
    });
    return response.text();
  };

  const verifyPhoneFetch = async () => {
    const _formData = new FormData();
    _formData.append("code", verifyCode);
    _formData.append("phone", phone);
    setIsSendingData(true);
    const response = await fetch(API_BASE_URL + "verify", {
      method: "POST",
      body: _formData,
    });

    return response.json();
  };

  const validateForm = () => {
    if (name.length < 5) {
      toast.error("نام خود را کامل وارد کنید");
      return;
    }
    if (phone.length !== 11) {
      toast.error("شماره تلفن خود را به صورت صحیح وارد کنید");
      return;
    }
    if (district === "0") {
      toast.error("لطفا منطقه خود را انتخاب کنید");
      return;
    }
    if (address.length < 10) {
      toast.error("لطفا آدرس خود را کامل بنویسید");
      return;
    }
    return true;
  };
  const onFormSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      signUpFetch().then((response) => {
        setIsSendingData(false);
        if (response === "ok") {
          setShowPhoneVerifyForm(true);
        } else if (response === "repeate") {
          toast.error("این شماره قبلا ثبت شده است");
        } else {
          toast.error("Error XcpP");
        }
      });
    }
  };

  const onVerifyPhoneFormSubmit = (e: any) => {
    e.preventDefault();
    if (verifyCode.length === 5) {
      verifyPhoneFetch().then((response) => {
        setIsSendingData(false);
        if (response.state === "ok") {
          dispatch(
            loginUser({
              isLogin: true,
              token: response.token,
              userInfo: response.user_info,
            })
          );
          navigate("/");
        } else if (
          response.state === "incorrect" ||
          response.state === "wrong"
        ) {
          toast.error("کد اشتباه است");
        } else {
          toast.error("کد منقضی شده است");
        }
      });
    } else {
      toast.error("لظفا کد فعال سازی به به درستی وارد کنید");
    }
  };

  return (
    <>
      <div
        id='authentication-modal'
        aria-hidden='true'
        className=' w-full mx-auto p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full'
      >
        <div className=' w-full h-full max-w-md md:h-auto mx-auto'>
          <div className=' bg-white rounded shadow'>
            <div className='px-6 py-6 lg:px-8'>
              <div className='mb-8 text-4xl font-bold text-center'>ثبت نام</div>

              <form
                className={`space-y-6 ${showPhoneVerifyForm && "hidden"}`}
                action='#'
                onSubmit={onFormSubmit}
              >
                <div>
                  <label
                    htmlFor='subcode'
                    className='block mb-2 text-sm font-medium flex'
                  >
                    <div className='flex-1'>نام و نام خانوادگی </div>
                  </label>
                  <input
                    type='text'
                    onChange={(e) => setName(e.target.value)}
                    name='name'
                    className='bg-gray-50 border border-gray-300  text-sm rounded focus:border-rose-500 outline-rose-700 block w-full p-2'
                    placeholder=''
                  />
                </div>
                <div>
                  <label
                    htmlFor='phone'
                    className='block mb-2 text-sm font-medium'
                  >
                    شماره تلفن
                  </label>
                  <input
                    type='number'
                    minLength={11}
                    maxLength={11}
                    name='phone'
                    onChange={(e) => setPhone(e.target.value)}
                    className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                  />
                </div>
                <div>
                  <label
                    htmlFor='region'
                    className='block mb-2 text-sm font-medium'
                  >
                    منطقه
                  </label>
                  <select
                    onChange={(e) => setDistrict(e.target.value)}
                    className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                  >
                    <option value={0}>انتخاب کنید...</option>
                    {districts?.map((district: IDistrict) => (
                      <option
                        key={district.id}
                        value={district.id}
                      >
                        {district.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label
                    htmlFor='address'
                    className='block mb-2 text-sm font-medium'
                  >
                    آدرس کامل
                  </label>
                  <input
                    type='text'
                    name='address'
                    onChange={(e) => setAddress(e.target.value)}
                    className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                  />
                </div>

                <div className='flex items-center'>
                  <button
                    type='submit'
                    disabled={isSendingData}
                    className='flex-1 w-full cursor-pointer text-white bg-rose-900 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                  >
                    {isSendingData ? (
                      <FontAwesomeIcon
                        icon={faCircleNotch}
                        className='rotate-animation'
                      />
                    ) : (
                      "ثبت نام"
                    )}
                  </button>
                  <Link
                    to='/signin'
                    className='hover:underline p-2 rounded border border-rose-900 text-rose-900 mr-2'
                  >
                    ورود
                  </Link>
                </div>

                <div className='text-sm font-medium text-gray-500'></div>
              </form>

              <form
                className={`space-y-6 ${!showPhoneVerifyForm && "hidden"}`}
                action='#'
                onSubmit={onVerifyPhoneFormSubmit}
              >
                <div className='flex pb-4'>
                  <div className='flex-1'>
                    <div className='w-10 h-10 bg-green-500 mx-auto rounded-full text-lg text-white flex items-center'>
                      <span className='text-white text-center w-full'>
                        <FontAwesomeIcon icon={faCheck} />
                      </span>
                    </div>
                  </div>

                  <div className='w-1/2 align-center items-center align-middle content-center flex'>
                    <div className='w-full bg-grey-500 rounded items-center align-middle align-center flex-1'>
                      <div
                        className='bg-green-500 text-xs leading-none py-1 text-center text-grey-500 rounded '
                        style={{ width: "100%" }}
                      ></div>
                    </div>
                  </div>

                  <div className='flex-1'>
                    <div className='w-10 h-10 bg-white mx-auto border border-2 border-gray-300 rounded-full text-lg flex items-center'>
                      <span className=' text-center w-full text-gray-400'>
                        2
                      </span>
                    </div>
                  </div>
                </div>

                <div>
                  کد تاییدی که برای شماره{" "}
                  <span className='font-bold'>{phone}</span> ارسال شده است را
                  وارد کنید
                </div>

                <div>
                  <label
                    htmlFor='verifyCode'
                    className='block mb-2 text-sm font-medium flex'
                  >
                    <div className='flex-1'>کد تایید</div>
                  </label>

                  <div style={{ direction: "ltr" }}>
                    <OtpInput
                      value={verifyCode}
                      onChange={setVerifyCode}
                      numInputs={5}
                      inputType={"number"}
                      containerStyle={{ gap: "8px" }}
                      inputStyle={{
                        border: "2px solid #ccc",
                        flex: "1",
                        borderRadius: "4px",
                        padding: "8px",
                      }}
                      shouldAutoFocus={true}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>
                </div>
                <button
                  type='submit'
                  disabled={isSendingData}
                  className='flex-1 w-full text-white bg-rose-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                >
                  {isSendingData ? (
                    <FontAwesomeIcon
                      icon={faCircleNotch}
                      className='rotate-animation'
                    />
                  ) : (
                    "تایید "
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
